import React, { Component } from 'react';

import './GovernancaNossosForuns.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views,
	governanca_content
} from '../../settings';

import {
	Person,
	HoveredImage,
	Compromisso
} from '../../components/';

class GovernancaNossosForuns extends Component {

	constructor() {
		super();

        this.images = images;
        this.governanca_content = governanca_content;

        this.state = {
            width: window.innerWidth,
        	compromissosStep: null,
        	compromisso0: '',
        	compromisso1: '',
        	compromisso2: '',
        	compromisso3: '',
        	compromisso4: '',
        	compromisso5: '',
        	activeButtons: 'compromissos__buttons--0',
        	intervalId: 0,
        	currentSlide: 0,
        	maxSlides: 5,
        	sliderTime: 15000
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeCompromissos = this.changeCompromissos.bind(this);
	    this.changeCompromissosButton = this.changeCompromissosButton.bind(this);
	    this.changeCompromissosMobileNext = this.changeCompromissosMobileNext.bind(this);
	    this.changeCompromissosMobilePrev = this.changeCompromissosMobilePrev.bind(this);
	    this.timer = this.timer.bind(this);

        this.scene;
        this.parallaxInstance;
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    changeCompromissos(num) {
    	console.log('changeCompromissos', num);
    	if (this.state.compromissosStep != num) {
    		this.setState({
    			compromissosStep : num,
    			activeButtons: 'compromissos__buttons--' + num
    		});

    		this.setState({
    			compromisso0 : '',
    			compromisso1 : '',
    			compromisso2 : '',
    			compromisso3 : '',
    			compromisso4 : '',
    			compromisso5 : ''
    		});

    		switch (num) {
    			case 0:
    				this.setState({ compromisso0 : 'active' });
    				break;
    			case 1:
    				this.setState({ compromisso1 : 'active' });
    				break;
    			case 2:
    				this.setState({ compromisso2 : 'active' });
    				break;
    			case 3:
    				this.setState({ compromisso3 : 'active' });
    				break;
    			case 4:
    				this.setState({ compromisso4 : 'active' });
    				break;
    			case 5:
    				this.setState({ compromisso5 : 'active' });
    				break;
    		}
    	}
    }

    changeCompromissosButton(num) {
    	this.changeCompromissos(num);
    	this.clearTimer();
    	this.initTimer();
    }

    changeCompromissosMobileNext() {
    	let nextCompromisso = this.state.compromissosStep + 1;
    	this.changeCompromissos( (nextCompromisso <= this.state.maxSlides) ? nextCompromisso : 0 );
    	this.reloadTimer();
	}

    changeCompromissosMobilePrev() {
    	let prevCompromisso = this.state.compromissosStep - 1;
    	this.changeCompromissos( (prevCompromisso >= 0) ? prevCompromisso : this.state.maxSlides );
    	this.reloadTimer();
	}

	timer() {
		let newSlide;

		if (this.state.compromissosStep < this.state.maxSlides) {
			newSlide = this.state.compromissosStep + 1;
		} else {
			newSlide = 0;
		}

		console.log('newSlide', newSlide);

		this.changeCompromissos(newSlide);
		// this.setState({ compromissosStep : newSlide });
	}

	reloadTimer() {
    	this.clearTimer();
    	this.initTimer();
	}

	clearTimer() {
		clearInterval(this.state.intervalId);
	}

	initTimer() {
		var intervalId = setInterval(this.timer, this.state.sliderTime);
		this.setState({ intervalId: intervalId });
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    initParallax() {
        this.scene = document.getElementById('scene');
        this.parallaxInstance = new Parallax(this.scene);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('4.6 Nossos fóruns');
    }

    componentWillUnmount() {
		this.clearTimer();
	}

    componentDidMount() {
    	this.initTimer();
    	this.changeCompromissos(0);
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view', 
			'nossos-foruns'
		];

		let slideClassItem = [
			'compromissos__body',
			'compromissos__body--' + this.state.compromissosStep
		];

		let compromissoButtonsClassItem = [
			'compromissos__buttons', this.state.activeButtons
		];

		let compromisso0ClassItem = [
			'compromissos__btn',
			'compromissos__btn--mercado-capitais',
			'compromissos__btn--' + this.state.compromisso0
		];

		let compromisso1ClassItem = [
			'compromissos__btn',
			'compromissos__btn--fundos-investimento',
			'compromissos__btn--' + this.state.compromisso1
		];

		let compromisso2ClassItem = [
			'compromissos__btn',
			'compromissos__btn--tesouraria',
			'compromissos__btn--' + this.state.compromisso2
		];

		let compromisso3ClassItem = [
			'compromissos__btn',
			'compromissos__btn--distribuicao',
			'compromissos__btn--' + this.state.compromisso3
		];

		let compromisso4ClassItem = [
			'compromissos__btn',
			'compromissos__btn--produtos-servicos',
			'compromissos__btn--' + this.state.compromisso4
		];

		let compromisso5ClassItem = [
			'compromissos__btn',
			'compromissos__btn--apoio',
			'compromissos__btn--' + this.state.compromisso5
		];


        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>4.6 Nossos fóruns - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>4.6</span> Nossos fóruns</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Governança corporativa</p>
		        			</div>
		        		</header>

		        		<div className="views__content first_view row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				Debatemos temas que colaborem para o futuro do mercado em diferentes comitês, subcomitês e grupos de trabalho permanentes e pontuais. Para dar suporte às atividades de supervisão dos mercados, há comissões de acompanhamento e conselhos de autorregulação.
										</p>
										<h3>Comitês e subcomitês</h3>
										<p>Mais de mil profissionais indicados pelas instituições associadas fazem parte voluntariamente de 21 comitês e 14 subcomitês.<br />Eles discutem melhorias que são levadas para a Diretora, avaliadas em audiência pública e encaminhadas aos órgãos reguladores.</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding column--no-padding-mobile text-center column__first_image">
					        		<HoveredImage
				        				image1={ this.images.nossos_foruns_img1 }
				        				image2={ this.images.nossos_foruns_img1_hover } />
				        		</div>

			        		</div>
		        		</div>



		        		<div className="views__content views__content--section row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Comitês e subcomitês</h2>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section compromissos">
			        		<Swipeable
		        				className="row compromissos__header"
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<img className="compromissos_arrow" src={ this.images.quem_somos_perfil_arrow } />

				        		<div className={ compromissoButtonsClassItem.join(' ') }>
					        		<div className={ compromisso0ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 0) }>
					        			<span className="btn__text">Mercado de<br />capitais</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso1ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 1) }>
					        			<span className="btn__text">Fundos de<br />investimento</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso2ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 2) }>
					        			<span className="btn__text">Tesouraria</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso3ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 3) }>
					        			<span className="btn__text">Distribuição</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso4ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 4) }>
					        			<span className="btn__text">Produtos<br />e serviços</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso5ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 5) }>
					        			<span className="btn__text">Apoio</span>
					        			<div className="btn__loader"></div>
					        		</div>
				        		</div>
			        		</Swipeable>
			        		<Swipeable
			        			className={ slideClassItem.join(' ') }
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_mercado_de_capitais }
			        				title="Mercado<br />de capitais"
			        				slug="mercado-de-capitais">
			        				<div className="compromisso__content">
				        				<h3>Comitê Finanças Corporativas</h3>
				        				<h4>Subcomitês</h4>
				        				<ul>
				        					<li>Agentes Fiduciários</li>
											<li>Ranking de Financiamento de Projetos</li>
											<li>Ranking de Fusões e Aquisições</li>
											<li>Ranking de Renda Fixa e Híbridos</li>
											<li>Renda Variável</li>
				        				</ul>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_fundo_investimento }
			        				title="Fundos de<br />investimento"
			        				slug="fundos-investimento">
			        				<div className="compromisso__content">
				        				<h3>Comitê FIP</h3>
				        				<p>(Fundos de Investimento em Participações)</p>
				        				<h3>Comitê FIDC</h3>
				        				<p>(Fundos de Investimento em Direitos Creditórios)</p>
				        				<h3>Comitê Fundos de Ações</h3>
				        				<h3>Comitê Fundos de Renda Fixa & Multimercados</h3>
				        				<h4>Subcomitês</h4>
				        				<ul>
				        					<li>ETFs (Exchange Traded Funds)</li>
											<li>Produtos Previdenciários</li>
				        				</ul>

				        				<h3>Comitê Serviços Qualificados</h3>
				        				<h4>Subcomitês</h4>
				        				<ul>
				        					<li>Administração Fiduciária</li>
											<li>Custódia</li>
											<li>Escrituração de Ativos</li>
											<li>Investidores não Residentes</li>
				        				</ul>

				        				<h3>Comitê Produtos Financeiros Imobiliários</h3>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_tesouraria }
			        				title="Tesouraria"
			        				slug="tesouraria">
			        				<div className="compromisso__content">
				        				<h3>Comitê Assuntos de Tesouraria</h3>
				        				<h3>Comitê Produtos de Tesouraria</h3>
				        				<h4>Subcomitê</h4>
				        				<ul>
				        					<li>Produtos de Tesouraria</li>
				        				</ul>
				        				<h3>Comitê Representação do Selic</h3>
				        				<h3>Comitê Mercado</h3>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_distribuicao }
			        				title="Distribuição"
			        				slug="distribuicao">
			        				<div className="compromisso__content">
				        				<h3>Comitê Private Banking</h3>
				        				<h3>Comitê Varejo</h3>
				        				<h3>Comitê Gestão de Patrimônio</h3>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_produtos_servicos }
			        				title="Produtos<br />e serviços"
			        				slug="produtos-servicos">
			        				<div className="compromisso__content">
				        				<h3>Comitê Certificação</h3>
				        				<h3>Comitê Acompanhamento Macroeconômico</h3>
				        				<h3>Comitê Precificação de Ativos</h3>
				        				<h4>Subcomitê</h4>
				        				<ul>
				        					<li>Benchmarks</li>
				        				</ul>
				        				<h3>Comitê Educação de Investidores</h3>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.nossos_foruns_icon_apoio }
			        				title="Apoio"
			        				slug="apoio">
			        				<div className="compromisso__content">
				        				<h3>Comitê Assuntos Contábeis</h3>
				        				<h3>Comitê Assuntos Jurídicos</h3>
				        				<h3>Comitê Compliance</h3>
				        				<h4>Subcomitê</h4>
				        				<ul>
				        					<li>Compliance de Assets</li>
				        				</ul>
			        				</div>
			        			</Compromisso>
			        		</Swipeable>
		        		</div>

		        		<div className="views__content views__content--section row comissoes__view view__gray">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<h2 className="section_title">Conselhos e comissões</h2>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section row comissoes__view comissoes__view--topics view__gray">

			        		<div className="container">
				        		<div className="column column--half column--padding-right column--border-right">
				        			<Fade bottom>
				        				<h3>Comissões de acompanhamento</h3>
					        			<p>Formadas por representantes de instituições associadas, orientam a atuação da área de supervisão de mercados. Analisam e encaminham os relatórios sobre as investigações relacionadas às instituições que não cumprirem as exigências dos códigos.</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--padding-left">
				        			<Fade bottom>
				        				<h3>Conselhos de regulação e melhores práticas </h3>
					        			<p>Compostos por membros nomeados pela Diretoria e por representantes de outras entidades de mercado para garantir independência nas decisões. Realizam a instauração e o julgamento de processos envolvendo instituições que seguem os códigos de autorregulação e a emissão de deliberações e pareceres de orientação a respeito desses códigos.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section row comissoes__view comissoes__view--topics view__gray">

			        		<div className="container">
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
				        				<h3>Há nove comissões e nove conselhos<br classaName="hide_mobile" />sobre os assuntos:</h3>
					        			
					        			<ul>
					        				<li>Certificação</li>
											<li>FIP e FIEE</li>
											<li>Fundos de Investimento</li>
											<li>Gestão de Patrimônio</li>
											<li>Mercado de Capitais</li>
											<li>Negociação de Instrumentos Financeiros</li>
											<li>Private Banking</li>
											<li>Serviços Qualificados</li>
											<li>Varejo</li>
					        			</ul>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img src={ this.images.nossos_foruns_img2 } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { GovernancaNossosForuns };
